import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/initiatives.css';

const initiativesData = [
  { id: 1, title: "Best Nation IT & Skill Institutes & Universities", category: "education", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "IT training, skill institutes and linkages with universities to upskill youth.", faIcon: "fa-laptop-code" },
  { id: 2, title: "Health Awareness, Ambulance Service & Clean Water Program", category: "health", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Health camps, ambulance services and clean water initiatives for communities.", faIcon: "fa-ambulance" },
  { id: 3, title: "Darul Rahmat for Orphans & Special Children", category: "orphans", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Shelter, education and medical care for orphans and specially-abled children.", faIcon: "fa-child" },
  { id: 4, title: "Best Nation Taleem & Literacy Program", category: "education", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Adult literacy, formal schooling support and community learning centers.", faIcon: "fa-book" },
  { id: 5, title: "Clean Green & Drug Free Pakistan", category: "community", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Tree planting, awareness campaigns and drug rehabilitation support.", faIcon: "fa-seedling" },
  { id: 6, title: "Best Nation Entrepreneurship & Employment Program", category: "education", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Business skills, startups support and job placement assistance.", faIcon: "fa-briefcase" },
  { id: 7, title: "Quran-o-Sunnat Awareness & Spiritual Healing Program", category: "religion", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Religious education, spiritual counseling and community seminars.", faIcon: "fa-quran" },
  { id: 8, title: "Dialysis Center, Blood Bank & Thalassaemia Centers", category: "health", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Medical support including dialysis, blood bank services and thalassaemia care.", faIcon: "fa-procedures" },
  { id: 9, title: "Youth & Women Empowerment Programs", category: "empower", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Leadership, vocational training and entrepreneurship for youth and women.", faIcon: "fa-users" },
  { id: 10, title: "Parenting & Teachers Training Program", category: "education", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Capacity building for parents and teachers to improve child outcomes.", faIcon: "fa-chalkboard-teacher" },
  { id: 11, title: "Sports & Cultural Programs", category: "community", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Community sports, cultural events and youth development activities.", faIcon: "fa-futbol" },
  { id: 12, title: "Human Rights, Legal Support & Nikah Salah Program", category: "legal", cost: "Varies", raised: "30%", goal: "Varies", progress: 30, desc: "Legal aid, awareness on rights and family services including nikah facilitation.", faIcon: "fa-gavel" }
];

const categories = [
  { value: "all", label: "All" },
  { value: "education", label: "Education & Skills" },
  { value: "health", label: "Healthcare" },
  { value: "orphans", label: "Orphan Care" },
  { value: "community", label: "Community" },
  { value: "empower", label: "Empowerment" },
  { value: "religion", label: "Religious" },
  { value: "legal", label: "Legal & Rights" }
];

export default function Initiatives({ data = null, title = "Best Nation Services & Initiatives" }) {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("all");

  const list = data && Array.isArray(data) ? data : initiativesData;

  const filteredData = activeFilter === "all"
    ? list
    : list.filter(item => item.category === activeFilter);

  const handleDonateClick = (title) => {
    navigate(`/donate?cause=${encodeURIComponent(title)}`);
  };

  return (
    <section className="initiatives-section" id="initiatives">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <p>Our Projects</p>
          <h2>{title}</h2>
        </div>

        {/* Filter Navigation */}
        <div className="initiatives-filters">
          {categories.map(cat => (
            <button
              key={cat.value}
              className={`filter-btn ${activeFilter === cat.value ? 'active' : ''}`}
              onClick={() => setActiveFilter(cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Initiatives Grid */}
        <div className="row g-4 justify-content-center">
          {filteredData.map(item => (
            <div className="col-lg-4 col-md-6" key={item.id}>
              <div className="initiative-card glass-card text-center">
                {/* Alkhidmat Signature Circle Icon header */}
                <div className="card-icon-wrap">
                  <div className="card-circle-icon">
                    <i className={`fa ${item.faIcon}`} />
                  </div>
                  <span className="card-tag">{categories.find(c => c.value === item.category)?.label}</span>
                </div>
                
                <div className="card-body-content">
                  <div className="card-cost-badge mx-auto">
                    <i className="fa fa-hand-holding-heart me-1" />
                    {item.cost}
                  </div>
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-description">{item.desc}</p>
                  
                  {/* Progress Bar */}
                  <div className="card-progress-section">
                    <div className="progress-labels">
                      <span className="raised-label">Raised: <strong>{item.raised}</strong></span>
                      <span className="percent-label">{item.progress}%</span>
                    </div>
                    <div className="progress-bar-track">
                      <div className="progress-bar-fill" style={{ width: `${item.progress}%` }} />
                    </div>
                    <div className="progress-goal">Goal: {item.goal}</div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-custom w-100 mt-4"
                    onClick={() => handleDonateClick(item.title)}
                  >
                    <i className="fa fa-heart me-1" /> Donate Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
